<template lang="pug">
  .productionChart
    highcharts(
      :options="options"
      :updateArgs="updateArgs"
      ref="chart"
    )
</template>

<script>
import { Chart } from 'highcharts-vue'
import Highcharts from 'highcharts'
import More from 'highcharts/highcharts-more'
More(Highcharts)

export default {
  name: 'ProductionChart',
  props: {
    data: {},
    height: {},
    width: {},
    aiscChartField: {},
    exchangeRate: {}
  },
  data: function () {
    return {
      updateArgs: [true, true, { duration: 1000 }]
    }
  },
  components: {
    highcharts: Chart
  },
  watch: {
  },
  computed: {
    options () {
      let op = {
        chart: {
          animation: true,
          width: this.width,
          height: this.height
        },
        title: {
          text: ''
        },
        legend: {
          enabled: true
        },
        xAxis: {
          categories: this.data.labels
        },
        yAxis: [{
        // Primary
          labels: {
            format: '{value}'
          },
          title: {
            text: 'Production per Year (koz)'
          }
        },
        // Secondary
        {
          labels: {
            // eslint-disable-next-line no-template-curly-in-string
            format: '${value}'
          },
          title: {
            text: 'AISC ($/oz)'
          },
          opposite: true
        }
        ],
        tooltip: {
          followPointer: true,
          shared: true,
          valueDecimals: 0
        },
        plotOptions: {
          column: {
            stacking: 'normal'
          }
        },
        credits: {
          enabled: false
        },
        series: [
          {
            name: 'Gold Production',
            type: 'column',
            color: '#cedbb4',
            data: this.data.goldProduction,
            legendIndex: 1
          },
          {
            name: 'All-in-Sustaining Cost ($/oz)',
            type: 'spline',
            color: '#a8bfac',
            data: this.data[this.aiscChartField].map((x) => {
              return x * this.exchangeRate
            }),
            yAxis: 1,
            legendIndex: 10

          }
        ]
      }
      if (this.data.silverProductionGoldEq.reduce(function (a, b) { return a + b }) > 0) {
        op['series'].unshift({
          name: 'Silver Production (Gold-Eq)',
          type: 'column',
          color: '#b8d9eb',
          data: this.data.silverProductionGoldEq,
          legendIndex: 2
        })
      }
      if (this.data.copperProductionGoldEq.reduce(function (a, b) { return a + b }) > 0) {
        op['series'].unshift({
          name: 'Copper Production (Gold-Eq)',
          type: 'column',
          color: '#d7a35e',
          data: this.data.copperProductionGoldEq,
          legendIndex: 3
        })
      }
      return op
    }
  },
  methods: {
  },
  created () {
  },
  mounted () {
  }
}
</script>
